import axios from "axios";

// const baseURL = "http://localhost:4000/api/";
const baseURL = "https://api.kalamkids.in/api/";

// const baseURL = "https://kalam-kids-api.vercel.app/api/";

const axiosInstance = axios.create({
  baseURL,
});

const publicAxios = axios.create({
  baseURL,
  // baseURL: "http://localhost:4000/api/",
  // baseURL: "https://kalam-kids-api.vercel.app/api/",
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token"); // Get the token from local storage
    if (token) {
      config.headers.Authorization = `Bearer ${token}`; // Set the token in the Authorization header
    }
    const selectedBranchId = localStorage.getItem("selectedBranchId");
    if (selectedBranchId) {
      config.headers['x-branch-id'] = selectedBranchId;
    }

    const academicYear = localStorage.getItem("academicYear"); // Get academic year from local storage
    if (academicYear && (!config.params || config.params.academicYear === undefined)) {
      config.params = { ...config.params, academicYear }; // Add academicYear as a query parameter
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      localStorage.removeItem("token");
      localStorage.removeItem("role");
      localStorage.removeItem("branches");
      localStorage.removeItem("selectedBranchId");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Function to create a form
export const createForm = async (data) => {
  try {
    const response = await publicAxios.post("form/submit", data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const createfollow = async (data) => {
  try {
    const response = await axiosInstance.post("form/follow-ups", data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const getfollowup = async (enquiryId) => {
  try {
    const response = await axiosInstance.get(`form/follow-ups/${enquiryId}`);
    if (!response.data.success && response.status === 200) {
      // Backend correctly indicated no follow-ups, but with 200 status
      return response.data; // Return the message and success: false
    }
    return response.data;
  } catch (error) {
    handleAxiosError(error);
    throw error;
  }
};
export const createBill = async (selectedForm, data) => {
  try {
    const response = await axiosInstance.post(`form/${selectedForm._id}/pay`, data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const createMiscBill = async (data) => {
  try {
    const response = await axiosInstance.post("misc-bills/", data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const getAllMiscBills = async () => {
  try {
    const response = await axiosInstance.get("misc-bills/");
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const updateMiscBill = async (id, data) => {
  try {
    const response = await axiosInstance.put(`misc-bills/${id}`, data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const deleteMiscBill = async (id) => {
  try {
    const response = await axiosInstance.delete(`misc-bills/${id}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const getMiscBillById = async (id) => {
  try {
    const response = await axiosInstance.get(`misc-bills/${id}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
// Functio  n to create an enquiry
export const createEnquiry = async (data) => {
  try {
    const response = await publicAxios.post("form/enquiry", data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const createExpansive = async (data) => {
  try {
    const response = await axiosInstance.post("expansive/expansive", data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const promoteForm = async (id, { newClass, newFeeAmount, newAcademicYear }) => {
  try {
    const response = await axiosInstance.put(`form/promote/${id}`, {
      newClass,
      newFeeAmount,
      newAcademicYear,
    });
    return response.data;
  } catch (error) {
    console.error("Error promoting form:", error);
    throw error;
  }
};
export const getExpansive = async () => {
  try {
    const response = await axiosInstance.get(`expansive/get-expansive`);
    return response.data;
  } catch (error) {
    console.error("Error fetching expansive data:", error);
    throw error;
  }
};
export const getExpansiveById = async (id) => {
  try {
    const response = await axiosInstance.get(`expansive/expansive/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching expansive by ID:", error);
    throw error;
  }
};
export const updateExpansive = async (id, data) => {
  try {
    const response = await axiosInstance.put(`expansive/expansive/${id}`, data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const updateForm = async (id, formData) => {
  try {
    const response = await axiosInstance.put(`form/update/${id}`, formData);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const deleteExpansive = async (id) => {
  try {
    const response = await axiosInstance.delete(`expansive/expansive/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting expansive:", error);
    throw error;
  }
};
export const deleteEnq = async (id) => {
  try {
    const response = await axiosInstance.delete(`form/enq/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting Enquiry:", error);
    throw error;
  }
};
export const updateEnq = async (id, data) => {
  try {
    const response = await axiosInstance.put(`form/enq/${id}`, data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const approveForm = async (id, { feeAmount }) => {
  try {
    const response = await axiosInstance.put(`form/approve/${id}`, {
      feeAmount,
    });
    return response.data;
  } catch (error) {
    console.error("Error approving form:", error);
    throw error;
  }
};
export const approveVocher = async (id, amount) => {
  try {
    const response = await axiosInstance.post(
      `expansive/expansive/${id}/approve`,
      { amount }
    );
    return response.data;
  } catch (error) {
    console.error("Error approving form:", error);
    throw error;
  }
};
export const getApprovedForms = async (academicYear = "") => {
  try {
    const params = { academicYear };
    const response = await axiosInstance.get(`form/approved`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching approved forms:", error);
    throw error;
  }
};
export const getOverallPayment = async (academicYear = "") => {
  try {
    const params = { academicYear };
    const response = await axiosInstance.get(`form/overall-payment`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching overall payment:", error);
    throw error;
  }
};
export const getAllCategories = async () => {
  try {
    const response = await axiosInstance.get("category/");
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    throw error;
  }
};

// Function to create a new category
export const createCategory = async (categoryData) => {
  try {
    const response = await axiosInstance.post("category/", categoryData);
    return response.data;
  } catch (error) {
    console.error("Error creating category:", error);
    throw error;
  }
};

// Function to update an existing category
export const updateCategory = async (id, categoryData) => {
  try {
    const response = await axiosInstance.put(
      `category/${id}`,
      categoryData
    );

    return response.data;

  } catch (error) {
    console.error("Error updating category:", error);
    throw error;
  }
};
export const getCategory = async () => {
  try {
    const response = await axiosInstance.get(`category/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching  category:", error);
    throw error;
  }
};
// Function to delete a category
export const deleteCategory = async (id) => {
  try {
    const response = await axiosInstance.delete(`category/${id}`);
    return response.data;
  }
  catch (error) {
    handleAxiosError(error);
  }
};

// Function to get a student by ID
export const getEnqById = async (id) => {
  try {
    const response = await axiosInstance.get(`form/students/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching student by ID:", error);
    throw error;
  }
};
export const getBillbyId = async (formId, id) => {
  try {
    const response = await axiosInstance.get(`form/${formId}/payment/${id}`); // Corrected endpoint
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const getAllPayments = async () => {
  try {
    const response = await axiosInstance.get(`form/getbill`); // Assumes GET /api/payments returns all payments
    return response.data.data; // Assuming response has { success: true, data: [...] }
  } catch (error) {
    console.error("Error fetching all payments:", error);
    throw error;
  }
};

// Function to get a student by ID
export const getFormById = async (id) => {
  try {
    const response = await axiosInstance.get(`form/form/${id}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const getAllPaymentsById = async (id) => {
  try {
    const response = await axiosInstance.get(`form/${id}/payments`);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const getAdmissions = async (data) => {
  try {
    const response = await axiosInstance.get("form/form", data); // Corrected endpoint
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const getAllForm = async (academicYear = "") => {
  try {
    const params = { academicYear };
    const response = await axiosInstance.get("form/form", { params }); // Corrected endpoint
    return response.data;
  }
  catch (error) {
    handleAxiosError(error);
  }
};
export const getAllStudents = async (params = {}) => {
  try {
    const response = await axiosInstance.get("form/students", { params });
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const getCount = async (academicYear = "") => {
  try {
    const params = { academicYear };
    const response = await axiosInstance.get("form/counts", { params }); // Corrected endpoint
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};
export const deleteForm = async (id) => {
  try {
    const response = await axiosInstance.delete(`form/forms/${id}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const getAllBranches = async () => {
  try {
    const response = await axiosInstance.get("branch/");
    return response.data;
  } catch (error) {
    console.error("Error fetching branches:", error);
    throw error;
  }
};

export const createBranch = async (branchData) => {
  try {
    const response = await axiosInstance.post("branch/", branchData);
    return response.data;
  } catch (error) {
    console.error("Error creating branch:", error);
    throw error;
  }
};

export const updateBranch = async (id, branchData) => {
  try {
    const response = await axiosInstance.put(`branch/${id}`, branchData);
    return response.data;
  } catch (error) {
    console.error("Error updating branch:", error);
    throw error;
  }
};

export const deleteBranch = async (id) => {
  try {
    const response = await axiosInstance.delete(`branch/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting branch:", error);
    throw error;
  }
};

// Helper function to handle Axios errors
const handleAxiosError = (error) => {
  if (error.response) {
    console.error("Error sending request:", error.response.data);
    const errorMessage =
      error.response.data?.message ||
      (typeof error.response.data === 'string' ? error.response.data : null) ||
      error.response.statusText ||
      "An error occurred";
    throw new Error(errorMessage);
  } else if (error.request) {
    console.error("No response received:", error.request);
    throw new Error("No response from server");
  } else {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred");
  }
};
// src/api.js (or wherever your API functions are defined)
export const loginUser = async (username, password) => {
  try {
    const response = await axiosInstance.post("auth/login", {
      username,
      password,
    });
    localStorage.setItem("token", response.data.token);
    localStorage.setItem("role", response.data.role); // Store the user's role
    return response.data;
  } catch (error) {
    console.error("Error logging in:", error);
    throw error;
  }
};
export const getDashboardData = async () => {
  try {
    const response = await axiosInstance.get("auth/dashboard");
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

export const createPredefinedMiscItem = async (data) => {
  try {
    const response = await axiosInstance.post("predefined-misc-item", data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const getAllPredefinedMiscItems = async () => {
  try {
    const response = await axiosInstance.get("predefined-misc-item");
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const updatePredefinedMiscItem = async (id, data) => {
  try {
    const response = await axiosInstance.put(`predefined-misc-item/${id}`, data);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const deletePredefinedMiscItem = async (id) => {
  try {
    const response = await axiosInstance.delete(`predefined-misc-item/${id}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

// User registration API function
export const registerUser = async (userData) => {
  try {
    const response = await axiosInstance.post("auth/register", userData);
    return response.data;
  } catch (error) {
    console.error("Error registering user:", error);
    throw error;
  }
};

export const sendAdmissionLink = async (enquiryId, frontendBaseUrl) => {
  try {
    const response = await axiosInstance.post(`form/${enquiryId}/send-admission-link`, { frontendBaseUrl });
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};

export const validateAdmissionToken = async (token) => {
  try {
    const response = await axiosInstance.get(`form/validate-admission-token/${token}`);
    return response.data;
  } catch (error) {
    handleAxiosError(error);
  }
};